










































import {Component, Vue} from "vue-property-decorator";
import YcHeader from "@/components/common/yc-header.vue"
import YcAside from "@/components/common/yc-aside.vue"
import {sendVerifyEmail, verify, verifySuccess} from "@/services/api"

@Component({
  components: {
    'yc-header': YcHeader
  },
})
export default class EmailVerify extends Vue {
  public email = '';
  public showHelp = false;
  public timer!: number;

  created(): void {
    this.email = String(this.$route.query.email);
    this.verify();
  }

  verify() {
    this.timer = setInterval(() => {
      verify({email: this.email}).then(res => {
        if(res.data.data !== '未验证通过') {
          clearInterval(this.timer);
          this.$message.success(this.$t('views.emailverify.text_90ae7bb19a8c8bc1') as string);
          this.$router.push('/home');
        }
      })
    },10000)
  }

  beforeDestroy() {
    clearInterval(this.timer);
  }

  /**
   * 发送验证邮件
   */
  sendVerifyEmail(message: boolean = true) {
    sendVerifyEmail({email: this.email}).then(res => {
      message && this.$message.success(this.$t('views.emailverify.text_91cd65b053d19001') as string)
    })
  }

  changeEmail() {
    clearInterval(this.timer);
    this.$prompt(
      this.$t('views.emailverify.text_65b090ae7bb1') as string,
      this.$t('views.emailverify.text_66f4653990ae7bb1') as string,
      {
        confirmButtonText: this.$t('views.emailverify.text_786e5b9a') as string,
        cancelButtonText: this.$t('views.emailverify.text_53d66d88') as string,
        closeOnClickModal: false,
        inputValue: this.email,
        inputValidator: (value: any,) => {
          if(!value) {
            return this.$t('views.emailverify.text_8bf78f93516553d1') as string
          } else if (value.length > 200) {
            return this.$t('views.emailverify.text_957f5ea64e0d80fd') as string;
          } else if (!(new RegExp("[\\w!#$%&'*+/=?^_`{|}~-]+(?:\\.[\\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\\w](?:[\\w-]*[\\w])?\\.)+[\\w](?:[\\w-]*[\\w])?")).test(value)) {
            return this.$t('views.emailverify.text_8bf78f9351656b63') as string;
          } else {
            return true;
          }
        }
      }).then(({value}: any) => {
      this.sendVerifyEmail(true);
      this.email = value;
      this.$router.push(`/email/verify?email=${this.email}`);
    }).catch(() => {
      this.verify();
    });
  }
}
